import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function submitInquiry(payload) {
  const { data } = await axios.post(`${API}/inquiry`, payload);
  return data;
}

export async function getReviews() {
  const { data } = await axios.get(`${API}/reviews`);
  return data;
}

export async function getGeoLang() {
  const { data } = await axios.get(`${API}/geo-lang`);
  return data;
}
